// extracted by mini-css-extract-plugin
export var centered = "_t-6";
export var flexible = "_t-5";
export var footer = "_t-k";
export var footerBorder = "_t-l";
export var header = "_t-c";
export var headerBorder = "_t-d";
export var headerDefault = "_t-g";
export var headerMedium = "_t-h";
export var headerPadding = "_t-e";
export var iconAndTitle = "_t-f";
export var large = "_t-4";
export var largePadding = "_t-a";
export var medium = "_t-3";
export var mediumPadding = "_t-9";
export var modal = "_t-0";
export var modalContainer = "_t-b";
export var noPadding = "_t-7";
export var skinny = "_t-1";
export var small = "_t-2";
export var smallPadding = "_t-8";
export var subtitle = "_t-j";
export var title = "_t-i";